/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IAdvancedNotesData } from './advanced-notes.data';
import { IAdvancedNotesProps } from './advanced-notes.props.autogenerated';
import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import { IAdvancedNoteEntity } from '../../actions/DataServiceEntities.g';

export interface IAdvancedNotesViewProps extends IAdvancedNotesProps<IAdvancedNotesData> {
    staticDisplay: INodeProps;
    advancedNotesModuleProps: IModuleProps;
}

interface IAdvancedNotesExtendedProps extends IAdvancedNotesProps<IAdvancedNotesData> {
    notes: IAdvancedNoteEntity[];
}

interface IAdvancedNotesState {
    notes: IAdvancedNoteEntity[];
    isNoteAreaActive: boolean;
}
/**
 *
 * AdvancedNotes component
 * @extends {React.PureComponent<IAdvancedNotesProps<IAdvancedNotesData>>}
 */
class AdvancedNotes extends React.PureComponent<IAdvancedNotesExtendedProps, IAdvancedNotesState> {
    private _className = 'advanced-notes';
    constructor(props: IAdvancedNotesExtendedProps) {
        super(props);
        this.state = {
            notes: props.notes,
            isNoteAreaActive: false
        };
    }
    private _renderNote = (key: string, message: string): React.ReactNode => {
        return (
            <div className='advanced-notes-container__note-text' key={key}>
                <p>{message}</p>
            </div>
        );
    };

    private _renderNotes = (): React.ReactNode => {
        return (
            <div className='advanced-notes-container'>
                {this.props.notes.map((note, index) => {
                    return this._renderNote(`${index}${note.ItemId}`, note.TextValue || '');
                })}
            </div>
        );
    };

    /**
     * Renders the static comment display for when the isCommentAreaActive state param is false
     * @return React.ReactNode
     */
    private _renderStaticNotesDisplay = () => {
        const notes = this._renderNotes();
        return <div className='advanced-notes-wrapper'>{notes}</div>;
    };

    public render(): JSX.Element | null {
        const viewProps: IAdvancedNotesViewProps = {
            ...this.props,
            staticDisplay: {
                tag: 'div',
                className: `${this._className}__static-display`,
                children: this._renderStaticNotesDisplay()
            },
            advancedNotesModuleProps: {
                tag: 'div',
                className: `${this._className}`,
                moduleProps: { ...this.props }
            }
        };
        return this.props.renderView(viewProps);
    }
}

export default AdvancedNotes;
